<template>
    <div class="changeNewPassword">
        <div class="changeNewPassword-input-item">
            <p class="chagneNewPhone-new-title">请输入新密码</p>
            <div class="changePhone-code">
                <van-field v-model="password" :type="showPwd ? 'text' : 'password'" center clearable placeholder="请输入新密码">
                    <template #button>
                        <img v-if="showPwd" src="@/assets/images/user/pwd-show.png" @click="showPwd = !showPwd" alt="" />
                        <img v-else src="@/assets/images/user/pwd-hide.png" @click="showPwd = !showPwd" alt="" />
                    </template>
                </van-field>
            </div>
            <p class="changeNewPassword-tips">密码长度不能少于6位且必须包含数字和字母</p>
        </div>
        <div class="changeNewPassword-input-item">
            <p class="chagneNewPhone-new-title">再次确认密码</p>
            <div class="changePhone-code">
                <van-field v-model="rePassword" :type="showPwd ? 'text' : 'password'" center clearable placeholder="请再次确认密码">
                    <template #button>
                        <img v-if="showPwd" src="@/assets/images/user/pwd-show.png" @click="showPwd = !showPwd" alt="" />
                        <img v-else src="@/assets/images/user/pwd-hide.png" @click="showPwd = !showPwd" alt="" />
                    </template>
                </van-field>
            </div>
        </div>
        <div class="changePhone-confirm-btn">
            <van-button class="comfirm-btn" :disabled="disabled" @click="confirmChange" color="#009AF3">完成</van-button>
        </div>
    </div>
</template>

<script>
import rule from "@/libs/fieldValidateRules";
import { updatePwdApi } from "@/api/index";
import cookieFunc from "@/libs/cookie";
export default {
    name: "ChangeNewPassword",
    data() {
        return {
            password: "",
            rePassword: "",
            smsCode: "",
            phoneNo: "",
            second: 60,
            timer: null,
            showPwd: false,
            sendCodeText: "短信验证码",
        };
    },
    computed: {
        disabled() {
            if (this.password != "" && this.rePassword != "") {
                return false;
            } else {
                return true;
            }
        },
    },
    mounted() {
        this.getCode();
    },
    methods: {
        getCode() {
            this.smsCode = this.$route.query.code;
            this.phoneNo = this.$route.query.phone;
        },
        sendCode() {
            if (this.second == 60) {
                this.timer = setInterval(() => {
                    if (this.second > 0) {
                        this.second -= 1;
                        this.sendCodeText = this.second + "s后重新获取";
                    } else {
                        this.sendCodeText = "短信验证码";
                        this.second = 60;
                        clearInterval(this.timer);
                    }
                }, 1000);
                this.$notify({
                    message: "验证码已发送，请注意查收",
                    color: "#009AF3",
                    background: "#D3E8FB",
                });
            } else {
            }
        },
        confirmChange() {
            if (!rule.checkPasswordLetterNumber.regex.test(this.password)) {
                this.$toast(rule.checkPasswordLetterNumber.errorMsg);
            } else if (!rule.checkPasswordLetterNumber.regex.test(this.rePassword)) {
                this.$toast(rule.checkPasswordLetterNumber.errorMsg);
            } else if (this.password != this.rePassword) {
                this.$toast("密码不同");
            } else {
                let params = {
                    password: this.password,
                    phoneNo: this.phoneNo,
                    smsCode: this.smsCode,
                };
                updatePwdApi(params).then((res) => {
                    this.$toast("修改成功");
                    cookieFunc.delCookie("token");
                    cookieFunc.delCookie("userInfo");
                    this.$router.push("/login");
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.changeNewPassword {
    min-height: 100vh;
    background-color: #fff;
    padding-top: 124px;
    .changeNewPassword-input-item {
        padding: 0 72px;
        margin-bottom: 55px;
        .chagneNewPhone-new-title {
            font-size: 32px;
            font-weight: 500;
            color: #333333;
        }

        .changePhone-code {
            border-bottom: 1px solid #dbdada;
            padding-bottom: 34px;
            margin-top: 45px;
            img {
                width: 32px;
                height: 24px;
            }
        }
        .changeNewPassword-tips {
            font-size: 24px;
            color: #f72d2d;
            margin-top: 23px;
        }
    }
    .changePhone-confirm-btn {
        padding: 24px;
        // margin-top: ;
    }
}
</style>
<style lang="less">
.changePhone-code {
    .van-cell {
        padding: 0;
    }
}
</style>
